import {Component, OnInit} from '@angular/core';
import {AuthAccessProvider} from '../core/core.auth';
import {MessageProvider} from '../service/message.service';
import {UserService} from '../service/user.service';
import {CheckhrService} from '../service/checkhr.service';
import {BusyProvider} from '../service/busy.service';
import {AppConstants} from '../core/app.constants';
import {Router} from '@angular/router';
import {UserContext, User, BaseComponent, ElCheckhr, CheckhrUser} from '../core/core.component';
import {SelectItem} from 'primeng/primeng';
import {Message} from 'primeng/components/common/api';

declare var $: any;

@Component({
  selector: 'app-checkhr-users',
  templateUrl: './checkhr-users.component.html',
  styleUrls: ['./checkhr-users.component.css'],
})
export class CheckhrUsersComponent extends BaseComponent implements OnInit {

  locale: any = AppConstants.ITA_CALENDAR_CONF;
  userContext: UserContext;
  loading = false;
  showDeleteAlert = false;
  showFilter = false;

  checkhrs: SelectItem[] = [];
  users: SelectItem[] = [];

  filterCheckhrId: number = null;
  filterUserId: number = null;
  filterDateFrom: Date = null;
  filterDateTo: Date = null;
  filterExpDateFrom: Date = null;
  filterExpDateTo: Date = null;
  filterStorico = false;

  elements: CheckhrUser[] = [];

  elementSelected: CheckhrUser = new CheckhrUser();
  validationMessage: string = null;

  elementUserId: number = null;
  elementId: number = null;
  elementData: Date = new Date();
  elementNote: string = null;

  oggi: Date = new Date();

  msgs: Message[] = [];

  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private userService: UserService,
    private checkhrService: CheckhrService,
    private busyProvider: BusyProvider) {
    super(authAccess, router, messageProvider);
    this.messageProvider.clearAll();
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.resetFilter();
      this.loadCheckhrs();
      this.loadUsers();
      this.loadCheckhrUsers();
    }
  }

  resetFilter() {
    this.filterCheckhrId = null;
    this.filterUserId = null;
    this.filterDateFrom = null;
    this.filterDateTo = null;
    this.filterExpDateFrom = null;
    this.filterExpDateTo = null;
    this.filterStorico = false;
  }

  loadCheckhrs() {
    this.checkhrs = [];
    this.checkhrService.getCheckhrElements(this.userContext.srmToken).subscribe(
      result => {
        this.checkhrs.push({label: '', value: null});
        const checkhrs = result.elements;
        for (let i = 0; i < checkhrs.length; ++i) {
          const current: ElCheckhr = checkhrs[i];
          this.checkhrs.push({label: current.desc, value: current.id});
        }
      },
      error => {
        this.handleError(error);
      });
  }

  loadUsers() {
    this.users = [];
    this.userService.getUsers(this.userContext.srmToken).
      subscribe(
      result => {
        this.users.push({label: '', value: null});
        for (let i = 0; i < result.users.length; ++i) {
          const current: User = result.users[i];
          this.users.push({label: current.fullname, value: current.id});
        }
      },
      error => {
        this.handleError(error);
      });
  }

  loadCheckhrUsers() {
    this.elements = [];
    this.loading = true;
    this.checkhrService.getCheckhrUsers(this.userContext.srmToken, this.filterCheckhrId, this.filterUserId,
      this.filterDateFrom, this.filterDateTo, this.filterExpDateFrom, this.filterExpDateTo, this.filterStorico).subscribe(

      result => {
        this.elements = result.checkhrs;
        this.elements.sort(function(a, b) {
          let i = +new Date(a.dataScadenza) - +new Date(b.dataScadenza);
          if (i === 0) {
            i = a.desUser > b.desUser ? 1 : -1;
          }
          return i;
        });
        this.loading = false;
        if (this.elementSelected != null && this.elementSelected.idElCheckhr > 0) {
          this.selectElement(this.elementSelected);
        }
      },
      error => {
        this.handleError(error);
        this.loading = false;
      });
  }

  getRowClass(current: CheckhrUser) {
    let styleClass = '';
    if (current.data === this.elementSelected.data && current.idElCheckhr === this.elementSelected.idElCheckhr && current.idUser === this.elementSelected.idUser) {
      styleClass += 'selectedRow ';
    }
    if (+new Date(current.dataScadenza) < +this.oggi) {
      let maxData: Date = null;
      for (const element of this.elements) {
        if (element.idElCheckhr === current.idElCheckhr && element.idUser === current.idUser) {
          maxData = (maxData == null || +new Date(maxData) < +new Date(element.data)) ? element.data : maxData;
        }
      }
      if (current.data === maxData) {
        styleClass += 'inScadenza ';
      } else {
        styleClass += 'scaduto ';
      }
    } else {
      if ((new Date(current.dataScadenza).getTime() - (1000 * 60 * 60 * 24 * current.elCheckhr.numGiorniAlert)) < +this.oggi) {
        styleClass += 'inScadenza ';
      }
    }
    return styleClass;
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  applyFilter() {
    this.loadCheckhrUsers();
    this.showFilter = false;
  }

  removeFilter() {
    this.resetFilter();
    this.loadCheckhrUsers();
    this.showFilter = false;
  }

  selectElement(element: CheckhrUser) {
    this.validationMessage = null;
    this.elementSelected = element;
    this.elementUserId = element.idUser;
    this.elementId = element.idElCheckhr;
    this.elementData = element.data;
    this.elementNote = element.note;
  }

  addNewCheckhrUser() {
    this.validationMessage = null;
    this.messageProvider.clearAll();
    this.elementSelected = new CheckhrUser();
    this.elementUserId = this.checkhrs.length > 0 ? this.checkhrs[0].value : 0;
    this.elementId = this.checkhrs.length > 0 ? this.checkhrs[0].value : 0;
    this.elementData = new Date();
    this.elementNote = null;
  }

  storeCheckhrUser() {
    this.messageProvider.clearAll();
    this.validationMessage = null;

    if (this.elementUserId == null || this.elementUserId === 0) {
      this.validationMessage = 'Selezionare l\'utente';
      return;
    }
    if (this.elementId == null || this.elementId === 0) {
      this.validationMessage = 'Selezionare la scadenza';
      return;
    }
    if (this.elementData == null) {
      this.validationMessage = 'Inserire la data';
      return;
    }

    // modifica
    if (this.elementSelected.idElCheckhr > 0) {
      this.busyProvider.showBusyIndicator();
      this.checkhrService.updateNoteCheckhrUser(this.userContext.srmToken, this.elementSelected.data, this.elementSelected.idUser,
        this.elementSelected.idElCheckhr, this.elementSelected.dataScadenza, this.elementNote).subscribe(
        result => {
          this.busyProvider.hideBusyIndicator();
          this.msgs = [];
          this.msgs.push({severity: 'success', summary: 'OK', detail: 'Modifica eseguita correttamente'});
          this.loadCheckhrUsers();
        },
        error => {
          this.busyProvider.hideBusyIndicator();
          this.handleError(error);
        });
    } else {  // inserimento
      this.busyProvider.showBusyIndicator();
      this.checkhrService.insertCheckhrUser(this.userContext.srmToken, this.elementData, this.elementUserId, this.elementId, null, this.elementNote).subscribe(
        result => {
          this.busyProvider.hideBusyIndicator();
          this.msgs = [];
          this.msgs.push({severity: 'success', summary: 'OK', detail: 'Scadenza inserita correttamente'});
          this.addNewCheckhrUser();
          this.loadCheckhrUsers();
        },
        error => {
          this.busyProvider.hideBusyIndicator();
          this.handleError(error);
        });
    }
  }

  openDeleteAlert(current: CheckhrUser) {
    this.selectElement(current);
    this.showDeleteAlert = true;
  }
  closeDeleteAlert() {
    this.showDeleteAlert = false;
  }

  deleteCheckhrUser() {
    this.messageProvider.clearAll();
    this.validationMessage = null;

    this.busyProvider.showBusyIndicator();
    this.checkhrService.deleteCheckhrUser(this.userContext.srmToken, this.elementSelected.data, this.elementSelected.idUser,
      this.elementSelected.idElCheckhr, this.elementSelected.dataScadenza).subscribe(
      result => {
        this.busyProvider.hideBusyIndicator();
        this.msgs = [];
        this.msgs.push({severity: 'success', summary: 'OK', detail: 'Cancellazione eseguita correttamente'});
        this.addNewCheckhrUser();
        this.loadCheckhrUsers();
      },
      error => {
        this.busyProvider.hideBusyIndicator();
        this.handleError(error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/checkhr-users/checkhr-users.component.ts